/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowBatchResponse {
    getFixupPrototypeFunction() { return WorkFlowBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowBatchResponse>): WorkFlowBatchResponse {
        let obj = Object.assign(new WorkFlowBatchResponse(), model);
        WorkFlowBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowBatchResponse>): WorkFlowBatchResponse {
        if (!model) return null;
        return WorkFlowBatchResponse.newInstance(<WorkFlowBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowBatchResponse) {
        if (!obj) return;

        models.WorkFlowBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowBatchResponse): boolean {
        Object.setPrototypeOf(obj, WorkFlowBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.WorkFlowDefinitionsBase.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.WorkFlowDefinitionsBase; };

}
